import { render, staticRenderFns } from "./AddOrEditInvestors.vue?vue&type=template&id=584031e2&"
import script from "./AddOrEditInvestors.vue?vue&type=script&lang=js&"
export * from "./AddOrEditInvestors.vue?vue&type=script&lang=js&"
import style0 from "./AddOrEditInvestors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports